module.exports = __webpack_public_path__ + "static/media/category.a78da497.svg";